<template>
  <div class="membership">
    <div v-if="!addPro" class="begin">
      <div class="header flex items-center justify-between">
        <div class="flex-one validate">
          <validate-option
            :is-invalid-number="invalidNumber"
            :is-pro-number="proNumber"
            @updatePosition="updatePosition"
          />
        </div>
        <div class="flex-one current-month ">
          <div class="search-bloc flex items-center justify-between">
            <div class="recherche-name">
              <div class="relative recherche justify-center items-center pl-8 pr-4 py-4 bg-white shadow rounded">
                <div class="icon-search absolute inset-y-0 left-0 flex items-center px-4">
                  <svg-icon
                    name="ic_search"
                    original
                    class="icon w-4 h-4"
                  />
                </div>
                <div class="search-input ml-4">
                  <label>
                    <input
                      v-model="search"
                      type="text"
                      :placeholder="$t('searchName')"
                      class="recherche-input"
                    >
                  </label>
                </div>
              </div>
            </div>
            <div class="select-pays">
              <town-select
                :status-list="statusList"
                @selectedValue="selectedValue"
              />
            </div>
          </div>
        </div>
      </div><br>
      <div class="user-list bg-white rounded font-semibold shadow p-6 flex items-center">
        <div class="flex-one item-color w-2/5">{{ $t('completeName') }}</div>
        <div class="flex-one item-color w-1/5">{{ $t('phone') }}</div>
        <div class="flex-one item-color w-1/3">{{ $t('email') }}</div>
        <div class="flex-one item-color w-1/6">{{ $t('sex') }}</div>
        <div class="flex-one item-color w-1/4">{{ $t('town') }}</div>
        <div class="flex-one item-color w-2/5">{{ $t('pointsMenu') }}</div>
        <div class="flex-one item-color w-1/12"></div>
      </div>
        <div v-if="isPosition === 1" class="list-user cursor-pointer">
        <div class="loading" :class="{ 'not_empty': isLoading === false }">
          <loading
            :active="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
            loader="dots"
            color="#0B5382"
            background-color="transparent"
          />
        </div>
        <div v-if="sortedArrayUser.length === 0 && !isLoading" class="no-student text-center text-lg py-32">
          {{ $t('noMembershipSSR') }}
        </div>
        <div v-if="!isLoading">
          <div
            v-for="(item, i) in sortedArrayUser"
            :key="i"
            class="waiting"
          >
            <membership-list
              :member-list="item"
              @click.native="showMembershipDetail(i, 'waiting')"
            />
          </div>

          <pagination-base
            :currentPage="currentPage"
            :totalPages="computedTotalPagesWaiting"
            :visiblePages="computedVisiblePagesWaiting"
            @page-change="handlePageChange"
          />
        </div>
      </div>
      <div v-if="isPosition === 2" class="list-user cursor-pointer">
        <div class="loading" :class="{ 'not_empty': isLoading === false }">
          <loading
            :active="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
            loader="dots"
            color="#0B5382"
            background-color="transparent"
          />
        </div>
        <div v-if="sortedArrayUserRejected.length === 0 && !isLoading" class="no-student text-center text-lg py-32">
          {{ $t('noRejectedAdded') }}
        </div>
        <div v-if="!isLoading">
          <div
            v-for="(item, i) in sortedArrayUserRejected"
            :key="i"
            class="waiting"
          >
            <membership-list
              :member-list="item"
              @click.native="showMembershipDetail(i, 'rejected')"
            />
          </div>

          <pagination-base
            :currentPage="currentPageRejected"
            :totalPages="computedTotalPagesRejected"
            :visiblePages="computedVisiblePagesRejected"
            @page-change="handlePageChangeRejected"
          />
        </div>
      </div>
      <div v-if="isPosition === 3" class="list-user cursor-pointer">
        <div class="loading" :class="{ 'not_empty': isLoading === false }">
          <loading
            :active="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
            loader="dots"
            color="#0B5382"
            background-color="transparent"
          />
        </div>
        <div v-if="sortedArrayPro.length === 0 && !isLoading" class="no-student text-center text-lg py-32">
          {{ $t('noProfessionalAdded') }}
        </div>
        <div v-if="!isLoading">
          <div
            v-for="(item, i) in sortedArrayPro"
            :key="i"
            class="waiting"
          >
            <pro-list
              :pro-list="item"
              @click.native="showMembershipDetail(i, 'pro')"
            />
          </div>

          <pagination-base
            :currentPage="currentPagePro"
            :totalPages="computedTotalPagesPro"
            :visiblePages="computedVisiblePagesPro"
            @page-change="handlePageChangePro"
          />
        </div>
      </div><br>
    </div>
    <membership-detail
      v-if="membershipDetail"
      :member-detail-infos="memberDetail"
      @closeMembershipDetail="closeMembershipDetail"
    />
    <add-pro
      v-if="addPro"
      @clickToGoBack="clickToGoBack"
    />
  </div>
</template>

<script>
import ValidateOption from '../../components/helper/membership/validate-option'
import TownSelect from '../../components/helper/town-select'
import MembershipList from '../../components/helper/membership/membership-list'
import MembershipDetail from '../../components/helper/membership/membership-detail'
import http from '../../plugins/http'
import apiRoute from '../../router/api-routes'
import AddPro from '../../components/helper/membership/add-pro'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import ProList from '../../components/helper/membership/pro-list'
import towns from '@/components/helper/add/allTowns'
import PaginationBase from '@/components/helper/add/pagination-base.vue'

export default {
  name: 'index',
  components: { PaginationBase, ProList, Loading, AddPro, MembershipDetail, MembershipList, TownSelect, ValidateOption },
  data () {
    return {
      isPosition: 1,
      isLoading: true,
      fullPage: false,
      addPro: false,
      membershipDetail: false,
      search: '',
      statusList: [...towns],
      trieOption: 'all',
      allMemberships: [],
      allMembershipsRejected: [],
      allUsersPro: [],
      memberDetail: {},
      invalidNumber: 0,
      proNumber: 0,
      nothing: false,
      nothingPro: false,
      nothingRejected: false,
      currentPage: 1,
      limit: 10,
      currentPagePro: 1,
      limitPro: 10,
      currentPageRejected: 1,
      limitRejected: 10
    }
  },
  created () {
    this.loadAllData()
  },
  mounted () {
    this.statusList.sort(function (x, y) {
      const a = x.name.toUpperCase()
      const b = y.name.toUpperCase()
      return a === b ? 0 : a > b ? 1 : -1
    })
    const all = { name: 'TOUT' }
    this.statusList.unshift(all)
  },
  computed: {
    filteredMembershipsWaiting () {
      let sorted = this.allMemberships

      if (this.trieOption !== 'all' && this.trieOption !== 'TOUT') {
        const town = this.trieOption.toLowerCase()
        sorted = sorted.filter(item =>
          this.safeLower(item.user && item.user.town) === town ||
          this.safeLower(item.user && item.user.location) === town
        )
      }

      if (this.search && this.search.trim() !== '') {
        const words = this.normalizeForSearch(this.search).trim().split(/\s+/).filter(w => w.length > 0)
        sorted = sorted.filter(item => {
          if (!item || !item.user) return false
          const u = item.user
          const haystack = [u.firstName, u.lastName, u.phone, u.email]
            .map(v => this.normalizeForSearch(v))
            .join(' ')
          return words.every(w => haystack.includes(w))
        })
      }

      return sorted
    },
    sortedArrayUser () {
      const start = (this.currentPage - 1) * this.limit
      return this.filteredMembershipsWaiting.slice(start, start + this.limit)
    },
    computedTotalPagesWaiting () {
      return Math.max(1, Math.ceil(this.filteredMembershipsWaiting.length / this.limit))
    },
    computedVisiblePagesWaiting () {
      return Math.min(5, this.computedTotalPagesWaiting)
    },

    filteredMembershipsRejected () {
      let sorted = this.allMembershipsRejected

      if (this.trieOption !== 'all' && this.trieOption !== 'TOUT') {
        const town = this.trieOption.toLowerCase()
        sorted = sorted.filter(item =>
          this.safeLower(item.user && item.user.town) === town ||
          this.safeLower(item.user && item.user.location) === town
        )
      }

      if (this.search && this.search.trim() !== '') {
        const words = this.normalizeForSearch(this.search).trim().split(/\s+/).filter(w => w.length > 0)
        sorted = sorted.filter(item => {
          if (!item || !item.user) return false
          const u = item.user
          const haystack = [u.firstName, u.lastName, u.phone, u.email]
            .map(v => this.normalizeForSearch(v))
            .join(' ')
          return words.every(w => haystack.includes(w))
        })
      }

      return sorted
    },
    sortedArrayUserRejected () {
      const start = (this.currentPageRejected - 1) * this.limitRejected
      return this.filteredMembershipsRejected.slice(start, start + this.limitRejected)
    },
    computedTotalPagesRejected () {
      return Math.max(1, Math.ceil(this.filteredMembershipsRejected.length / this.limitRejected))
    },
    computedVisiblePagesRejected () {
      return Math.min(5, this.computedTotalPagesRejected)
    },

    filteredUsersPro () {
      let sorted = this.allUsersPro

      if (this.trieOption !== 'all' && this.trieOption !== 'TOUT') {
        const town = this.trieOption.toLowerCase()
        sorted = sorted.filter(item => {
          const u = item && item.user ? item.user : {}
          return this.safeLower(u.town) === town || this.safeLower(u.location) === town
        })
      }

      if (this.search && this.search.trim() !== '') {
        const words = this.normalizeForSearch(this.search).trim().split(/\s+/).filter(w => w.length > 0)
        sorted = sorted.filter(item => {
          if (!item || !item.user) return false
          const u = item.user
          const haystack = [u.firstName, u.lastName, u.phone, u.email]
            .map(v => this.normalizeForSearch(v))
            .join(' ')
          return words.every(w => haystack.includes(w))
        })
      }

      return sorted
    },
    sortedArrayPro () {
      const start = (this.currentPagePro - 1) * this.limitPro
      return this.filteredUsersPro.slice(start, start + this.limitPro)
    },
    computedTotalPagesPro () {
      return Math.max(1, Math.ceil(this.filteredUsersPro.length / this.limitPro))
    },
    computedVisiblePagesPro () {
      return Math.min(5, this.computedTotalPagesPro)
    }
  },
  watch: {
    search () {
      this.currentPage = 1
      this.currentPageRejected = 1
      this.currentPagePro = 1
    },
    trieOption () {
      this.currentPage = 1
      this.currentPageRejected = 1
      this.currentPagePro = 1
    }
  },
  methods: {
    safeLower (value) {
      return (value === null || typeof value === 'undefined') ? '' : String(value).toLowerCase()
    },
    normalizeForSearch (value) {
      return this.safeLower(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    loadAllData () {
      this.isLoading = true
      Promise.all([
        this.loadAllMemberships(),
        this.loadAllMembershipsRejected(),
        this.loadAllUsersPro()
      ]).finally(() => {
        this.isLoading = false
      })
    },
    safeCreatedAt (item) {
      const t = item && item.ssr && item.ssr.createdAt
      const d = t ? new Date(t).getTime() : 0
      return isNaN(d) ? 0 : d
    },
    loadAllMemberships () {
      return http.post(apiRoute.baseURL + apiRoute.getAllDemand, {
        page: 1, limit: 10000, type: 'WAITING'
      }, {
        headers: { Authorization: `Bearer ${this.$store.getters.loginToken}` }
      }).then(response => {
        this.allMemberships = (response.rows || []).slice().sort((x, y) => this.safeCreatedAt(x) - this.safeCreatedAt(y))
      }).catch(error => {
        console.log(error)
      })
    },
    loadAllMembershipsRejected () {
      return http.post(apiRoute.baseURL + apiRoute.getAllDemand, {
        page: 1, limit: 10000, type: 'REJECTED'
      }, {
        headers: { Authorization: `Bearer ${this.$store.getters.loginToken}` }
      }).then(response => {
        this.allMembershipsRejected = (response.rows || []).slice().sort((x, y) => this.safeCreatedAt(x) - this.safeCreatedAt(y))
        this.invalidNumber = response.count
      }).catch(error => {
        console.log(error)
      })
    },
    loadAllUsersPro () {
      return http.post(apiRoute.baseURL + apiRoute.getAllUser, {
        type: 'DOCTOR', page: 1, limit: 10000
      }, {
        headers: { Authorization: `Bearer ${this.$store.getters.loginToken}` }
      }).then(response => {
        this.allUsersPro = (response.rows || []).slice().sort((x, y) => this.safeCreatedAt(x) - this.safeCreatedAt(y))
        this.proNumber = response.count
      }).catch(error => {
        console.log(error)
      })
    },
    handlePageChange (newPage) {
      this.currentPage = newPage
    },
    handlePageChangePro (newPage) {
      this.currentPagePro = newPage
    },
    handlePageChangeRejected (newPage) {
      this.currentPageRejected = newPage
    },
    getListTown () {
      http.get('https://bj-decoupage-territorial.herokuapp.com/api/v1/towns')
        .then(response => { this.statusList = response.towns })
        .catch(error => { console.log(error) })
    },
    clickToGoBack (val) {
      this.addPro = val
    },
    showAddPro () {
      this.addPro = true
    },
    closeMembershipDetail () {
      this.membershipDetail = false
    },
    showMembershipDetail (index, type) {
      if (type === 'waiting') {
        this.memberDetail = this.sortedArrayUser[index]
      } else if (type === 'rejected') {
        this.memberDetail = this.sortedArrayUserRejected[index]
      } else if (type === 'pro') {
        this.memberDetail = this.sortedArrayPro[index]
      }
      this.membershipDetail = true
    },
    selectedValue (answer) {
      this.trieOption = answer
    },
    updatePosition (val) {
      this.isPosition = val
      switch (val) {
      case 1:
        this.isLoading = true
        setTimeout(() => { this.isLoading = false }, 1000)
        break
      case 2:
        this.isLoading = true
        setTimeout(() => { this.isLoading = false }, 1000)
        break
      case 3:
        this.isLoading = true
        setTimeout(() => { this.isLoading = false }, 1000)
        break
      }
    },
    onCancel () {
      console.log('User cancelled the loader.')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/assets/style/sass/variables";
  .membership {
    padding: 2rem 4rem 4rem 1.5rem;
  }
  .user-list {
    color: $light_gray;
  }
  .loading {
    position: relative;
    height: 10vh;
  }
  .not_empty {
    height: auto;
  }
</style>
